import React, { useState, useEffect } from 'react';

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const isMobile = window.innerWidth <= 640; // Mobile breakpoint

      if (isMobile) {
        // Show button near bottom on mobile
        // setIsVisible(scrollTop + windowHeight >= docHeight - 100);
        setIsVisible(scrollTop > 300);
      } else {
        // Show button after 300px scroll on desktop/tablet
        setIsVisible(scrollTop > 300);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      title="Go to top"
    //   className="fixed bottom-6 right-6 z-50 p-3 rounded-full bg-sky-600 hover:bg-sky-700 text-white shadow-lg transition focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
    className="fixed bottom-6 right-6 sm:right-6 sm:left-auto left-6 z-50 w-12 h-12 rounded-full bg-sky-600 hover:bg-sky-700 text-white shadow-lg transition focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 flex items-center justify-center"

    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"

        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}
